import { render, staticRenderFns } from "./shopownerCheck.vue?vue&type=template&id=dbedb92e&scoped=true&"
import script from "./shopownerCheck.vue?vue&type=script&lang=js&"
export * from "./shopownerCheck.vue?vue&type=script&lang=js&"
import style0 from "./shopownerCheck.vue?vue&type=style&index=0&id=dbedb92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbedb92e",
  null
  
)

export default component.exports